import { get, writable } from 'svelte/store';
import { stateUi } from '@infinitro/config';
import { ModalDialog, stateOpenModal } from './uiStore';
/** When true, the in-app support chat shell is visible (mirrors `stateUi.supportChat.useSupportChat`). */
export const stateSupportChatOpen = writable(false);
/** Mutually exclusive with the header's profile dropdown — they overlap on screen, so opening one closes the other. */
stateSupportChatOpen.subscribe((open) => {
    if (open && get(stateOpenModal) === ModalDialog.ProfileDropdown) {
        stateOpenModal.set(undefined);
    }
});
export function isSupportChatEmbedActive() {
    return get(stateUi).supportChat?.useSupportChat ?? false;
}
export function toggleSupportChatOpen() {
    stateSupportChatOpen.update((open) => !open);
}
